import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/icons/solid/image-fill.svg'
import _imports_1 from '@/assets/icons/solid/video-fill.svg'
import _imports_2 from '@/assets/icons/solid/roles-fill.svg'
import _imports_3 from '@/assets/icons/solid/list-bullet-fill.svg'
import _imports_4 from '@/assets/icons/solid/music-fill.svg'


const _hoisted_1 = { class: "mb-6" }
const _hoisted_2 = { class: "grid grid-cols-3 gap-6" }
const _hoisted_3 = { class: "col-span-3 lg:col-span-1" }
const _hoisted_4 = {
  key: 0,
  class: "w-96 h-75 rounded-md bg-gray-300 animate-pulse"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 2,
  class: "flex justify-center items-center object-cover w-96 h-75 rounded-md bg-gray-300"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  class: "grayed-icon h-10 w-10",
  src: _imports_0,
  alt: "picture icon"
}, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "col-span-3 lg:col-span-1" }
const _hoisted_10 = {
  key: 0,
  class: "w-96 h-75 rounded-md bg-gray-300 animate-pulse"
}
const _hoisted_11 = {
  key: 1,
  controls: "",
  class: "object-cover w-96 h-75 rounded-md"
}
const _hoisted_12 = ["src"]
const _hoisted_13 = {
  key: 2,
  class: "flex justify-center items-center object-cover w-96 h-75 rounded-md bg-gray-300"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("img", {
  class: "grayed-icon h-10 w-10",
  src: _imports_1,
  alt: "video icon"
}, null, -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { class: "col-span-3 lg:col-span-1" }
const _hoisted_17 = { class: "grid grid-cols-1" }
const _hoisted_18 = {
  key: 0,
  class: "col-span-1 lg:col-span-1 mt-10"
}
const _hoisted_19 = { class: "grid grid-cols-3 gap-6 grid-flow-rows mt-6" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-800 col-span-3 lg:col-span-1" }, " Scene Details ", -1)
const _hoisted_21 = { class: "text-gray-800 col-span-3 lg:col-span-2" }
const _hoisted_22 = { class: "col-span-3 lg:col-span-1 grid grid-cols-3 gap-4" }
const _hoisted_23 = { class: "col-span-1" }
const _hoisted_24 = { class: "col-span-1" }
const _hoisted_25 = { class: "col-span-1" }
const _hoisted_26 = { class: "col-span-1" }
const _hoisted_27 = { class: "col-span-1" }
const _hoisted_28 = { class: "col-span-1" }
const _hoisted_29 = { class: "col-span-3 lg:col-span-1 grid grid-cols-3 gap-4" }
const _hoisted_30 = { class: "col-span-1" }
const _hoisted_31 = { class: "col-span-1" }
const _hoisted_32 = { class: "col-span-1" }
const _hoisted_33 = { class: "col-span-1" }
const _hoisted_34 = { class: "col-span-1" }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = ["onClick"]
const _hoisted_37 = ["onClick"]
const _hoisted_38 = ["onClick"]
const _hoisted_39 = { key: 0 }
const _hoisted_40 = ["onClick"]
const _hoisted_41 = ["src"]
const _hoisted_42 = ["src"]
const _hoisted_43 = ["onClick"]
const _hoisted_44 = ["onClick"]
const _hoisted_45 = { key: 3 }
const _hoisted_46 = { class: "grid grid-cols-3 gap-6" }
const _hoisted_47 = { class: "col-span-3 lg:col-span-1" }
const _hoisted_48 = {
  key: 0,
  class: "w-96 h-75 rounded-md bg-gray-300 animate-pulse"
}
const _hoisted_49 = ["src"]
const _hoisted_50 = {
  key: 2,
  class: "flex justify-center items-center object-cover w-96 h-75 rounded-md bg-gray-300"
}
const _hoisted_51 = /*#__PURE__*/_createElementVNode("img", {
  class: "grayed-icon h-10 w-10",
  src: _imports_0,
  alt: "picture icon"
}, null, -1)
const _hoisted_52 = [
  _hoisted_51
]
const _hoisted_53 = { class: "col-span-3 lg:col-span-1" }
const _hoisted_54 = {
  key: 0,
  class: "w-96 h-75 rounded-md bg-gray-300 animate-pulse"
}
const _hoisted_55 = {
  key: 1,
  controls: "",
  class: "object-cover w-96 h-75 rounded-md"
}
const _hoisted_56 = ["src"]
const _hoisted_57 = {
  key: 2,
  class: "flex justify-center items-center object-cover w-96 h-75 rounded-md bg-gray-300"
}
const _hoisted_58 = /*#__PURE__*/_createElementVNode("img", {
  class: "grayed-icon h-10 w-10",
  src: _imports_1,
  alt: "video icon"
}, null, -1)
const _hoisted_59 = [
  _hoisted_58
]
const _hoisted_60 = { class: "col-span-3 lg:col-span-1" }
const _hoisted_61 = { class: "grid grid-cols-1" }
const _hoisted_62 = { class: "mt-8" }
const _hoisted_63 = {
  key: 0,
  class: "col-span-1 lg:col-span-1 mt-8"
}
const _hoisted_64 = ["onClick"]

import { // languages
		useI18n
	} from 'vue-i18n'

	import { 
		localesStore
	} from '@/store/locales'

	import { 
		store as _userStore
	} from '@/store/user'

	import { 
		getSceneDetailsByRecordId
	} from '../../../queries'

	import type {
		CustomSong
	} from '@/types'

	import {
		computed,
		inject,
		onMounted,
		ref 
	} from 'vue'

	
// name the component
	const __default__ = { name: 'SceneDetails' }

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
		openToTab: {
			type: Number,
			default: 0
		},
		scene: {
			type: Object,
			default: () => {return {}}
		},
		showDetails: {
			type: Function, 
			default: () => {return}
		}
	},
  setup(__props) {

	const props = __props

	const _localesStore = localesStore()
	const userStore = _userStore()

	const {t} = useI18n()
	
	const loading = ref(false)

	const tabs = ref()

	if(userStore.getContactType == 'Staff')
	{
		tabs.value =  [
			{ name: _localesStore.getLabel('176'), current: false },  // details
			{ name: _localesStore.getLabel('156'), current: false },  // participants
			{ name: _localesStore.getLabel('394'), current: false },  // variations
			{ name: _localesStore.getLabel('175'), current: false },  // options
			{ name: _localesStore.getLabel('179'), current: false },  // roles
			{ name: _localesStore.getLabel('694'), current: false }   // sound
		]
	}
	else
	{
		tabs.value =  [
			{ name: _localesStore.getLabel('176'), current: false },  // details
			{ name: _localesStore.getLabel('156'), current: false },  // participants
			{ name: _localesStore.getLabel('394'), current: false },  // variations
			{ name: _localesStore.getLabel('175'), current: false },  // options
			{ name: _localesStore.getLabel('694'), current: false }   // sound
		]
	}


	const childTabs = ref<{_tabs: []}>({_tabs: []})
	const standardRoles = ref()
	const musicianRoles = ref()

	const groupedRoles = computed(() => {
		let headings = []

		if(standardRoles.value?.length) {
			headings.push(
				{subheading: 'Standard Roles'},
				...standardRoles.value
			)
		}

		if(musicianRoles.value?.length) {
			headings.push(
				{subheading: 'Musician Roles'},
				...musicianRoles.value
			)
		}
		
		return headings
	})

	const participants = ref()
	const variations = ref()
	const options = ref()
	const songList = ref()
	const bgmList = ref()
	const liveList = ref()
	const data = ref()

	
	const filesLoading = ref(true)
	const liveFilesLoading = ref(true)
	const s3: any = inject('s3')
	const signedUrlPhoto = ref('')
	const signedUrlVideo = ref('')
	const signedUrlLivePhoto = ref('')
	const signedUrlLiveVideo = ref('')

	onMounted(async () => {
		// set active tab
		tabs.value[props.openToTab].current = true
		
		await fetchSceneDetails()

		fetchSceneMedia()

		if(isSong.value) { 
			fetchSongMedia()
		}
		else if(isLive.value) { 
			fetchLiveMedia()
		}
	})

	const customSongList = ref<CustomSong[]>([])

	async function fetchSceneDetails() {
		try { // fetching scene details
			loading.value = true

			const recordId = props.scene.recordId
			const contactId = userStore.user.contactId
			const sessionId = userStore.user.sessionId
			const jobId = props.scene['job__JOBS_SCENES__jobID::_kf_jobs_id']
			const scriptParams = JSON.stringify({
				language: _localesStore.getFmLanguage,
				sessionId,
				contactId,
				jobId
			})

			const params = `?script.prerequest=${encodeURI("Set Language")}&script.prerequest.param=${encodeURI(scriptParams)}`
			let res = await getSceneDetailsByRecordId(recordId, params)
			const record = res.response.data[0]
			
			data.value = record.fieldData
			const customSong = {
				song: data.value.customSongName,
				artist: data.value.customSongArtist,
				album: data.value.customSongAlbum,
				track: data.value.customSongTrackNum
			}
			customSongList.value.push(customSong)
			participants.value = record.portalData.jobs_scenes__JOBS_PARTICIPANTS__jobsSceneID
			variations.value = record.portalData.jobs_scenes__JOBS_VARIATIONS__jobsSceneID
			options.value = record.portalData.jobs_scenes__JOBS_SCENES_OPTIONS__jobsSceneID
			standardRoles.value = userStore.getContactType == 'Staff' ? record.portalData.standard_roles_staff : record.portalData.jobs_scenes__JOBS_SCENES_ROLES__jobsSceneStandardID
			musicianRoles.value = userStore.getContactType == 'Staff' ? record.portalData.musician_roles_staff : record.portalData.jobs_scenes__JOBS_SCENES_ROLES__jobsSceneInstrumentalID
			songList.value = record.portalData.jobs_scenes__JOBS_SONGS__jobsSceneID__cre
			bgmList.value = record.portalData.jobs_scenes__JOBS_BGMS__jobsSceneID
			liveList.value = record.portalData.jobs_scenes__JOBS_LIVE__jobsSceneID
		}
		catch(e) {
			console.error(e)
		}
		finally {
			loading.value = false
		}
	}

	async function fetchSceneMedia() {
		try { // fetching scene image and video from s3
			filesLoading.value = true
			const photoS3Json = JSON.parse(props.scene?.['job__job_scene__CONTACTS_SCENES__contactSceneID::s3JSONPicture'] || "{}")
			const photoKey = photoS3Json?.s3FilePathShortRaw
			const videoS3Json = JSON.parse(props.scene?.['job__job_scene__CONTACTS_SCENES__contactSceneID::s3JSONVideo'] || "{}")
			const videoKey = videoS3Json?.s3FilePathShortRaw
			
			if(photoKey) {
				let params = {
					Bucket: process.env.VUE_APP_S3_BUCKET,
					Key: photoKey
				}
	
				s3.getSignedUrlPromise('getObject', params).then(
					function (url: string) {
						signedUrlPhoto.value = url
					}, 
					function (err: Error) { 
						throw err
					}
				)
			}
			if(videoKey) {
				let params = {
					Bucket: process.env.VUE_APP_S3_BUCKET,
					Key: videoKey
				}
	
				s3.getSignedUrlPromise('getObject', params).then(
					function (url: string) {
						signedUrlVideo.value = url
					}, 
					function (err: Error) { 
						throw err
					}
				)
			}
		}
		catch(e) {
			console.error(e)
		}
		finally {
			filesLoading.value = false
		}
	}

	async function fetchSongMedia() {
		try { // fetching song files from s3
			songList.value.forEach((sound: any) => {
				const soundS3Json = JSON.parse(sound?.['jobs_scenes__jobs_songs__songs__SONGS_INFO__songsId::s3JSONSong'] || "{}")
				const soundKey = soundS3Json?.s3FilePathShortRaw
				
				if(soundKey) {
					let params = {
						Bucket: process.env.VUE_APP_S3_BUCKET,
						Key: soundKey
					}
		
					s3.getSignedUrlPromise('getObject', params).then(
						function (url: string) {
							sound.signedUrl = url
						}, 
						function (err: Error) { 
							throw err
						}
					)
				}
			})
		}
		catch(e) {
			console.error(e)
		}
	}

	async function fetchLiveMedia() {
		try { // fetching live image and video from s3
			liveFilesLoading.value = true
			const livePhotoS3Json = JSON.parse(props.scene?.["job__job_scene__LIVE__liveID::s3JSONPicture"] || "{}")
			const livePhotoKey = livePhotoS3Json?.s3FilePathShortRaw
			const liveVideoS3Json = JSON.parse(props.scene?.["job__job_scene__LIVE__liveID::s3JSONVideo"] || "{}")
			const liveVideoKey = liveVideoS3Json?.s3FilePathShortRaw
			
			if(livePhotoKey) {
				let params = {
					Bucket: process.env.VUE_APP_S3_BUCKET,
					Key: livePhotoKey
				}
	
				s3.getSignedUrlPromise('getObject', params).then(
					function (url: string) {
						signedUrlLivePhoto.value = url
					}, 
					function (err: Error) { 
						throw err
					}
				)
			}
			if(liveVideoKey) {
				let params = {
					Bucket: process.env.VUE_APP_S3_BUCKET,
					Key: liveVideoKey
				}
	
				s3.getSignedUrlPromise('getObject', params).then(
					function (url: string) {
						signedUrlLiveVideo.value = url
					}, 
					function (err: Error) { 
						throw err
					}
				)
			}
		}
		catch(e) {
			console.error(e)
		}
		finally {
			liveFilesLoading.value = false
		}
	}
	
	function hasPicture(row: any) {
		return row?.['jobs_scenes__jobs_scenes_options__SERVICES_OPTIONS__servicesOptionsID::s3JSONPicture'] ||
			row?.['jobs_scenes__jobs_scenes_options__CONTACTS_SCENES_OPTIONS__contactsScenesOptionsID::s3JSONPicture']
	}

	function hasVideo(row: any) {
		return row?.['jobs_scenes__jobs_scenes_options__SERVICES_OPTIONS__servicesOptionsID::s3JSONVideo'] ||
			row?.['jobs_scenes__jobs_scenes_options__CONTACTS_SCENES_OPTIONS__contactsScenesOptionsID::s3JSONVideo']
	}
	// Update when field is known
	function hasOptionRoles(row: any) {
		return row?.['jobs_scenes__jobs_scenes_options__JOBS_SCENES_OPTIONS_ROLES__jobsScenesOptionsInstrumentalID::_kp_jobs_scenes_options_roles_id'] ||
			row?.['jobs_scenes__jobs_scenes_options__JOBS_SCENES_OPTIONS_ROLES__jobsScenesOptionsStandardID::_kp_jobs_scenes_options_roles_id']
	}

	// Update when field is known
	function hasRoles(row: any) {
		return row?.['jobs_scenes__jobs_scenes_options__JOBS_SCENES_OPTIONS_ROLES__jobsScenesOptionsInstrumentalID::_kp_jobs_scenes_options_roles_id'] ||
			row?.['jobs_scenes__jobs_scenes_options__JOBS_SCENES_OPTIONS_ROLES__jobsScenesOptionsStandardID::_kp_jobs_scenes_options_roles_id']
	}

	// Update when field is known
	function hasInstructions(row: any) {
		return row?.['jobs_scenes__jobs_scenes_roles__INSTRUCTIONS_JOIN_JOBS_jobsScenesRolesID_standard::_kp_instructions_join_jobs_id'] ||
			row?.['jobs_scenes__jobs_scenes_roles__INSTRUCTIONS_JOIN_JOBS_jobsScenesRolesID_instrumental::_kp_instructions_join_jobs_id'] 
	}

	const isCustomSong = computed(() => {
		return props.scene?.['job__JOBS_SCENES__jobID::sound_choice'].toLowerCase().includes('song') && props.scene?.['job__JOBS_SCENES__jobID::customSongName']?.length
	})
	
	const isSong = computed(() => {
		return props.scene?.['job__JOBS_SCENES__jobID::sound_choice'].toLowerCase().includes('song') && !props.scene?.['job__JOBS_SCENES__jobID::customSongName']?.length
	})

	const isBgm = computed(() => {
		return props.scene?.['job__JOBS_SCENES__jobID::sound_choice'].toLowerCase().includes('bgm')
	})

	const isLive = computed(() => {
		return props.scene?.['job__JOBS_SCENES__jobID::sound_choice'].toLowerCase().includes('live')
	})

	function songHasScores(row: any) {
		return row?.['jobs_scenes__JOBS_SONGS_SCORES__jobsSceneID::_kp_jobs_songs_scores_id']
	}
	
	function bgmHasSongs(row: any) {
		return row?.['jobs_scenes__jobs_bgms__jobs_bgms_songs__SONGS__songsId::_kp_songs_id']
	}

	function liveHasSongs(row: any) {
		return row?.['jobs_scenes__jobs_live__LIVE_SONGS__jobsLiveID::_kp_live_songs_id']
	}

return (_ctx: any,_cache: any) => {
  const _component_tw_tabs_underline = _resolveComponent("tw-tabs-underline")!
  const _component_data_display = _resolveComponent("data-display")!
  const _component_CheckIconMini = _resolveComponent("CheckIconMini")!
  const _component_MinusIconMini = _resolveComponent("MinusIconMini")!
  const _component_tw_table_column = _resolveComponent("tw-table-column")!
  const _component_tw_table = _resolveComponent("tw-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_tw_tabs_underline, {
        ref_key: "childTabs",
        ref: childTabs,
        tabs: tabs.value
      }, null, 8, ["tabs"])
    ]),
    _withDirectives(_createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_data_display, {
            label: _unref(_localesStore).getLabel('293')
          }, {
            custom: _withCtx(() => [
              (filesLoading.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4))
                : (signedUrlPhoto.value)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      class: "object-cover w-96 h-75 rounded-md",
                      src: signedUrlPhoto.value
                    }, null, 8, _hoisted_5))
                  : (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_data_display, {
            label: _unref(_localesStore).getLabel('294')
          }, {
            custom: _withCtx(() => [
              (filesLoading.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10))
                : (signedUrlVideo.value)
                  ? (_openBlock(), _createElementBlock("video", _hoisted_11, [
                      _createElementVNode("source", {
                        type: "video/mp4",
                        src: signedUrlVideo.value
                      }, null, 8, _hoisted_12)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15))
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", null, [
              _createVNode(_component_data_display, {
                label: _unref(_localesStore).getLabel('205'),
                value: _unref(_userStore).getContactType === 'Staff' ? __props.scene?.['job__JOBS_SCENES__jobID::notes_staff_display'] : __props.scene?.['job__JOBS_SCENES__jobID::notes_client_display'] || '—'
              }, null, 8, ["label", "value"])
            ]),
            (_unref(userStore).getContactType === 'Staff')
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _createVNode(_component_data_display, {
                    label: _unref(_localesStore).getLabel('190'),
                    value: __props.scene?.['job__JOBS_SCENES__jobID::description_display'] || '—'
                  }, null, 8, ["label", "value"])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _hoisted_20,
        _createElementVNode("div", _hoisted_21, _toDisplayString(_unref(_localesStore).getLabel('676')), 1),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _createVNode(_component_data_display, {
              label: _unref(_localesStore).getLabel('388')
            }, {
              custom: _withCtx(() => [
                (__props.scene?.['job__JOBS_SCENES__jobID::main_scene'])
                  ? (_openBlock(), _createBlock(_component_CheckIconMini, {
                      key: 0,
                      class: "h-5 w-5 text-black"
                    }))
                  : (_openBlock(), _createBlock(_component_MinusIconMini, {
                      key: 1,
                      class: "h-5 w-5 text-gray-300"
                    }))
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createVNode(_component_data_display, {
              label: _unref(_localesStore).getLabel('411')
            }, {
              custom: _withCtx(() => [
                (__props.scene?.['job__JOBS_SCENES__jobID::standard'])
                  ? (_openBlock(), _createBlock(_component_CheckIconMini, {
                      key: 0,
                      class: "h-5 w-5 text-black"
                    }))
                  : (_openBlock(), _createBlock(_component_MinusIconMini, {
                      key: 1,
                      class: "h-5 w-5 text-gray-300"
                    }))
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createVNode(_component_data_display, {
              label: _unref(_localesStore).getLabel('192'),
              value: __props.scene?.['job__JOBS_SCENES__jobID::placement_display'] || '—'
            }, null, 8, ["label", "value"])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createVNode(_component_data_display, {
              label: `${_unref(_localesStore).getLabel('177')}/${_unref(_localesStore).getLabel('158')}/${_unref(_localesStore).getLabel('520')}`,
              value: __props.scene?.['job__JOBS_SCENES__jobID::sound_choice_display_first'] || '—'
            }, null, 8, ["label", "value"])
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createVNode(_component_data_display, {
              label: _unref(_localesStore).getLabel('389')
            }, {
              default: _withCtx(({row}) => [
                (row['job__JOBS_SCENES__jobID::spotlight'])
                  ? (_openBlock(), _createBlock(_component_CheckIconMini, {
                      key: 0,
                      class: "h-5 w-5 text-black"
                    }))
                  : (_openBlock(), _createBlock(_component_MinusIconMini, {
                      key: 1,
                      class: "h-5 w-5 text-gray-300"
                    }))
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createVNode(_component_data_display, {
              label: _unref(_localesStore).getLabel('541'),
              value: __props.scene?.['job__JOBS_SCENES__jobID::lighting'] || '—'
            }, null, 8, ["label", "value"])
          ])
        ]),
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("div", _hoisted_30, [
            _createVNode(_component_data_display, {
              label: _unref(_localesStore).getLabel('1'),
              value: __props.scene?.['job__JOBS_SCENES__jobID::time_type_display'] || '—'
            }, null, 8, ["label", "value"])
          ]),
          _createElementVNode("div", _hoisted_31, [
            _createVNode(_component_data_display, {
              label: _unref(_localesStore).getLabel('681'),
              value: __props.scene?.['job__JOBS_SCENES__jobID::time_relation_display'] || '—'
            }, null, 8, ["label", "value"])
          ]),
          _createElementVNode("div", _hoisted_32, [
            _createVNode(_component_data_display, {
              label: _unref(_localesStore).getLabel('376'),
              value: __props.scene?.['job__JOBS_SCENES__jobID::time_amount'] || '—'
            }, null, 8, ["label", "value"])
          ]),
          _createElementVNode("div", _hoisted_33, [
            _createVNode(_component_data_display, {
              label: _unref(_localesStore).getLabel('144'),
              value: _ctx.$filters.hour24Time(__props.scene?.['job__JOBS_SCENES__jobID::time_start']) || '—'
            }, null, 8, ["label", "value"])
          ]),
          _createElementVNode("div", _hoisted_34, [
            _createVNode(_component_data_display, {
              label: _unref(_localesStore).getLabel('322'),
              value: _ctx.$filters.hour24Time(__props.scene?.['job__JOBS_SCENES__jobID::time_end']) || '—'
            }, null, 8, ["label", "value"])
          ])
        ])
      ])
    ], 512), [
      [_vShow, childTabs.value?._tabs?.[0]?.current]
    ]),
    _withDirectives(_createElementVNode("div", null, [
      _createVNode(_component_tw_table, {
        placeholder: _unref(t)('placeholders.noParticipants'),
        data: participants.value,
        loading: loading.value
      }, {
        default: _withCtx(() => [
          _createVNode(_component_tw_table_column, {
            header: _unref(_localesStore).getLabel('1'),
            prop: "jobs_scenes__JOBS_PARTICIPANTS__jobsSceneID::type_display"
          }, null, 8, ["header"]),
          (_unref(userStore).getContactType == 'Staff')
            ? (_openBlock(), _createBlock(_component_tw_table_column, {
                key: 0,
                header: _unref(_localesStore).getLabel('386')
              }, {
                default: _withCtx(({row}) => [
                  (row?.['jobs_scenes__JOBS_PARTICIPANTS__jobsSceneID::unknown'])
                    ? (_openBlock(), _createBlock(_component_CheckIconMini, {
                        key: 0,
                        class: "h-5 w-5 text-black"
                      }))
                    : (_openBlock(), _createBlock(_component_MinusIconMini, {
                        key: 1,
                        class: "h-5 w-5 text-gray-300"
                      }))
                ]),
                _: 1
              }, 8, ["header"]))
            : _createCommentVNode("", true),
          _createVNode(_component_tw_table_column, {
            header: _unref(_localesStore).getLabel('225'),
            prop: "jobs_scenes__jobs_participants_PARTICIPANTS__participantID::name_display"
          }, null, 8, ["header"]),
          _createVNode(_component_tw_table_column, {
            header: _unref(_localesStore).getLabel('387')
          }, {
            default: _withCtx(({row}) => [
              (row?.['jobs_scenes__JOBS_PARTICIPANTS__jobsSceneID::rehearsal'])
                ? (_openBlock(), _createBlock(_component_CheckIconMini, {
                    key: 0,
                    class: "h-5 w-5 text-black"
                  }))
                : (_openBlock(), _createBlock(_component_MinusIconMini, {
                    key: 1,
                    class: "h-5 w-5 text-gray-300"
                  }))
            ]),
            _: 1
          }, 8, ["header"]),
          (_unref(userStore).getContactType == 'Staff')
            ? (_openBlock(), _createBlock(_component_tw_table_column, {
                key: 1,
                header: _unref(_localesStore).getLabel('102'),
                prop: "jobs_scenes__jobs_participants_ROLES__roleID::name_display"
              }, null, 8, ["header"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["placeholder", "data", "loading"])
    ], 512), [
      [_vShow, childTabs.value?._tabs?.[1]?.current]
    ]),
    _withDirectives(_createElementVNode("div", null, [
      _createVNode(_component_tw_table, {
        placeholder: _unref(t)('placeholders.noVariations'),
        data: variations.value,
        loading: loading.value
      }, {
        default: _withCtx(() => [
          _createVNode(_component_tw_table_column, {
            header: _unref(_localesStore).getLabel('395'),
            prop: "jobs_scenes__jobs_variations__VARIATIONS__variationID::name_display"
          }, null, 8, ["header"]),
          _createVNode(_component_tw_table_column, {
            header: _unref(_localesStore).getLabel('411')
          }, {
            default: _withCtx(({row}) => [
              (row['jobs_scenes__JOBS_VARIATIONS__jobsSceneID::standard'])
                ? (_openBlock(), _createBlock(_component_CheckIconMini, {
                    key: 0,
                    class: "h-5 w-5 text-black"
                  }))
                : (_openBlock(), _createBlock(_component_MinusIconMini, {
                    key: 1,
                    class: "h-5 w-5 text-gray-300"
                  }))
            ]),
            _: 1
          }, 8, ["header"]),
          (_unref(userStore).getContactType == 'Staff')
            ? (_openBlock(), _createBlock(_component_tw_table_column, {
                key: 0,
                "class-name": "w-6",
                "header-class-name": "w-6",
                "align-text": "right"
              }, {
                default: _withCtx(({row}) => [
                  _createElementVNode("div", {
                    class: "h-6 w-6 cursor-pointer",
                    onClick: ($event: any) => (__props.showDetails(row, 'varRoleDetails', 1))
                  }, [
                    _createElementVNode("img", {
                      class: _normalizeClass([hasRoles(row) ? 'linked-icon' : 'grayed-icon']),
                      src: _imports_2,
                      alt: "picture icon"
                    }, null, 2)
                  ], 8, _hoisted_35)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["placeholder", "data", "loading"])
    ], 512), [
      [_vShow, childTabs.value?._tabs?.[2]?.current]
    ]),
    _withDirectives(_createElementVNode("div", null, [
      _createVNode(_component_tw_table, {
        placeholder: _unref(t)('placeholders.noOptions'),
        data: options.value,
        loading: loading.value
      }, {
        default: _withCtx(() => [
          _createVNode(_component_tw_table_column, {
            header: _unref(_localesStore).getLabel('329'),
            prop: "jobs_scenes__jobs_scenes_options__SERVICES_OPTIONS__servicesOptionsID::name_display"
          }, null, 8, ["header"]),
          _createVNode(_component_tw_table_column, {
            header: _unref(_localesStore).getLabel('411')
          }, {
            default: _withCtx(({row}) => [
              (row['jobs_scenes__JOBS_SCENES_OPTIONS__jobsSceneID::standard'])
                ? (_openBlock(), _createBlock(_component_CheckIconMini, {
                    key: 0,
                    class: "h-5 w-5 text-black"
                  }))
                : (_openBlock(), _createBlock(_component_MinusIconMini, {
                    key: 1,
                    class: "h-5 w-5 text-gray-300"
                  }))
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_tw_table_column, {
            header: _unref(_localesStore).getLabel('11'),
            prop: "jobs_scenes__jobs_scenes_options__SERVICES_OPTIONS__servicesOptionsID::category_display"
          }, null, 8, ["header"]),
          (_unref(userStore).getContactType == 'Staff')
            ? (_openBlock(), _createBlock(_component_tw_table_column, {
                key: 0,
                header: _unref(_localesStore).getLabel('190'),
                prop: "jobs_scenes__jobs_scenes_options__SERVICES_OPTIONS__servicesOptionsID::description_display"
              }, null, 8, ["header"]))
            : _createCommentVNode("", true),
          _createVNode(_component_tw_table_column, {
            "class-name": "w-6",
            "header-class-name": "w-6",
            "align-text": "right"
          }, {
            default: _withCtx(({row}) => [
              _createElementVNode("div", {
                class: "h-6 w-6 cursor-pointer",
                onClick: ($event: any) => (__props.showDetails(row, 'optionsTabs', 0, null))
              }, [
                _createElementVNode("img", {
                  class: _normalizeClass([hasPicture(row) ? 'linked-icon' : 'grayed-icon']),
                  src: _imports_0,
                  alt: "picture icon"
                }, null, 2)
              ], 8, _hoisted_36)
            ]),
            _: 1
          }),
          _createVNode(_component_tw_table_column, {
            "class-name": "w-6",
            "header-class-name": "w-6",
            "align-text": "right"
          }, {
            default: _withCtx(({row}) => [
              _createElementVNode("div", {
                class: "h-6 w-6 cursor-pointer",
                onClick: ($event: any) => (__props.showDetails(row, 'optionsTabs', 0, null))
              }, [
                _createElementVNode("img", {
                  class: _normalizeClass([hasVideo(row) ? 'linked-icon' : 'grayed-icon']),
                  src: _imports_1,
                  alt: "picture icon"
                }, null, 2)
              ], 8, _hoisted_37)
            ]),
            _: 1
          }),
          (_unref(userStore).getContactType == 'Staff')
            ? (_openBlock(), _createBlock(_component_tw_table_column, {
                key: 1,
                "class-name": "w-6",
                "header-class-name": "w-6",
                "align-text": "right"
              }, {
                default: _withCtx(({row}) => [
                  _createElementVNode("div", {
                    class: "h-6 w-6 cursor-pointer",
                    onClick: ($event: any) => (__props.showDetails(row, 'optionsTabs', 1, null))
                  }, [
                    _createElementVNode("img", {
                      class: _normalizeClass([hasOptionRoles(row) ? 'linked-icon' : 'grayed-icon']),
                      src: _imports_2,
                      alt: "picture icon"
                    }, null, 2)
                  ], 8, _hoisted_38)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["placeholder", "data", "loading"])
    ], 512), [
      [_vShow, childTabs.value?._tabs?.[3]?.current]
    ]),
    (_unref(userStore).getContactType == 'Staff')
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_39, [
          _createVNode(_component_tw_table, {
            placeholder: _unref(t)('placeholders.noRoles'),
            data: groupedRoles.value,
            loading: loading.value
          }, {
            default: _withCtx(() => [
              _createVNode(_component_tw_table_column, {
                header: _unref(_localesStore).getLabel('102')
              }, {
                default: _withCtx(({row}) => [
                  _createTextVNode(_toDisplayString(row['jobs_scenes__jobs_scenes_roles_standard__ROLES_roleID::name_display'] ||
							row['jobs_scenes__jobs_scenes_roles_musician__ROLES_roleID::name_display']), 1)
                ]),
                _: 1
              }, 8, ["header"]),
              _createVNode(_component_tw_table_column, {
                "class-name": "w-6",
                "header-class-name": "w-6",
                "align-text": "right"
              }, {
                default: _withCtx(({row}) => [
                  _createElementVNode("div", {
                    onClick: ($event: any) => (__props.showDetails(row, 'scnRolesInstructionsList', null, null)),
                    class: "h-6 w-6 cursor-pointer"
                  }, [
                    _createElementVNode("img", {
                      class: _normalizeClass([ hasInstructions(row) ? 'linked-icon' : 'grayed-icon']),
                      src: _imports_3,
                      alt: "list icon"
                    }, null, 2)
                  ], 8, _hoisted_40)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["placeholder", "data", "loading"])
        ], 512)), [
          [_vShow, childTabs.value?._tabs?.[_unref(userStore).getContactType == 'Staff' ? 4 : 6]?.current]
        ])
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", null, [
      (isCustomSong.value)
        ? (_openBlock(), _createBlock(_component_tw_table, {
            key: 0,
            placeholder: _unref(t)('placeholders.noSongs'),
            data: customSongList.value,
            loading: loading.value
          }, {
            default: _withCtx(() => [
              _createVNode(_component_tw_table_column, {
                header: _unref(_localesStore).getLabel('177'),
                prop: "song"
              }, null, 8, ["header"]),
              _createVNode(_component_tw_table_column, {
                header: _unref(_localesStore).getLabel('282'),
                prop: "artist"
              }, null, 8, ["header"]),
              _createVNode(_component_tw_table_column, {
                header: _unref(_localesStore).getLabel('281'),
                prop: "album"
              }, null, 8, ["header"]),
              _createVNode(_component_tw_table_column, {
                header: _unref(_localesStore).getLabel('283'),
                prop: "track"
              }, null, 8, ["header"])
            ]),
            _: 1
          }, 8, ["placeholder", "data", "loading"]))
        : _createCommentVNode("", true),
      (isSong.value)
        ? (_openBlock(), _createBlock(_component_tw_table, {
            key: 1,
            placeholder: _unref(t)('placeholders.noSongs'),
            data: songList.value,
            loading: loading.value
          }, {
            default: _withCtx(() => [
              _createVNode(_component_tw_table_column, {
                header: _unref(_localesStore).getLabel('177'),
                prop: "jobs_scenes__jobs_songs__SONGS__songsId::name_display"
              }, null, 8, ["header"]),
              _createVNode(_component_tw_table_column, {
                header: _unref(_localesStore).getLabel('282'),
                prop: "jobs_scenes__jobs_songs__songs__ARTISTS__artistID::artist_display"
              }, null, 8, ["header"]),
              _createVNode(_component_tw_table_column, {
                header: _unref(_localesStore).getLabel('281'),
                prop: "jobs_scenes__jobs_songs__songs__ALBUMS__albumID::name_display"
              }, null, 8, ["header"]),
              _createVNode(_component_tw_table_column, {
                header: _unref(_localesStore).getLabel('283'),
                prop: "jobs_scenes__jobs_songs__SONGS__songsId::track"
              }, null, 8, ["header"]),
              _createVNode(_component_tw_table_column, {
                header: _unref(_localesStore).getLabel('529'),
                prop: "jobs_scenes__JOBS_SONGS__jobsSceneID__cre::order"
              }, null, 8, ["header"]),
              _createVNode(_component_tw_table_column, {
                "class-name": "w-6",
                "header-class-name": "w-6",
                "align-text": "right"
              }, {
                default: _withCtx(({row}) => [
                  _createElementVNode("audio", {
                    controls: "",
                    src: row.signedUrl
                  }, [
                    _createElementVNode("source", {
                      src: row.signedUrl,
                      type: "audio/mpeg"
                    }, null, 8, _hoisted_42),
                    _createTextVNode(" " + _toDisplayString(_unref(t)("placeholders.audioNotSupported")), 1)
                  ], 8, _hoisted_41)
                ]),
                _: 1
              }),
              _createVNode(_component_tw_table_column, {
                "class-name": "w-6",
                "header-class-name": "w-6",
                "align-text": "right"
              }, {
                default: _withCtx(({row}) => [
                  _createElementVNode("div", {
                    onClick: ($event: any) => (__props.showDetails(row, 'songScore', null, null)),
                    class: "h-6 w-6 cursor-pointer"
                  }, [
                    _createElementVNode("img", {
                      class: _normalizeClass([songHasScores(row) ? 'linked-icon' : 'grayed-icon']),
                      src: _imports_4,
                      alt: "list icon"
                    }, null, 2)
                  ], 8, _hoisted_43)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["placeholder", "data", "loading"]))
        : (isBgm.value)
          ? (_openBlock(), _createBlock(_component_tw_table, {
              key: 2,
              placeholder: _unref(t)('placeholders.noBgms'),
              data: bgmList.value,
              loading: loading.value
            }, {
              default: _withCtx(() => [
                _createVNode(_component_tw_table_column, {
                  header: _unref(_localesStore).getLabel('158'),
                  prop: "jobs_scenes__jobs_bgms__BGMS__bgmID::name_display"
                }, null, 8, ["header"]),
                _createVNode(_component_tw_table_column, {
                  header: _unref(_localesStore).getLabel('330'),
                  prop: "jobs_scenes__jobs_bgms__BGMS__bgmID::genre_display"
                }, null, 8, ["header"]),
                _createVNode(_component_tw_table_column, {
                  header: _unref(_localesStore).getLabel('190'),
                  prop: "jobs_scenes__jobs_bgms__BGMS__bgmID::description_display"
                }, null, 8, ["header"]),
                _createVNode(_component_tw_table_column, {
                  "class-name": "w-6",
                  "header-class-name": "w-6",
                  "align-text": "right"
                }, {
                  default: _withCtx(({row}) => [
                    _createElementVNode("div", {
                      onClick: ($event: any) => (__props.showDetails(row, 'bgmSong', null, null)),
                      class: "h-6 w-6 cursor-pointer"
                    }, [
                      _createElementVNode("img", {
                        class: _normalizeClass([bgmHasSongs(row) ? 'linked-icon' : 'grayed-icon']),
                        src: _imports_4,
                        alt: "list icon"
                      }, null, 2)
                    ], 8, _hoisted_44)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["placeholder", "data", "loading"]))
          : (isLive.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                _createElementVNode("div", _hoisted_46, [
                  _createElementVNode("div", _hoisted_47, [
                    _createVNode(_component_data_display, {
                      label: _unref(_localesStore).getLabel('293')
                    }, {
                      custom: _withCtx(() => [
                        (liveFilesLoading.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_48))
                          : (signedUrlLivePhoto.value)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 1,
                                class: "object-cover w-96 h-75 rounded-md",
                                src: signedUrlLivePhoto.value
                              }, null, 8, _hoisted_49))
                            : (_openBlock(), _createElementBlock("div", _hoisted_50, _hoisted_52))
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _createElementVNode("div", _hoisted_53, [
                    _createVNode(_component_data_display, {
                      label: _unref(_localesStore).getLabel('294')
                    }, {
                      custom: _withCtx(() => [
                        (liveFilesLoading.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_54))
                          : (signedUrlLiveVideo.value)
                            ? (_openBlock(), _createElementBlock("video", _hoisted_55, [
                                _createElementVNode("source", {
                                  type: "video/mp4",
                                  src: signedUrlLiveVideo.value
                                }, null, 8, _hoisted_56)
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_57, _hoisted_59))
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _createElementVNode("div", _hoisted_60, [
                    _createElementVNode("div", _hoisted_61, [
                      _createElementVNode("div", null, [
                        _createVNode(_component_data_display, {
                          label: _unref(_localesStore).getLabel('149'),
                          value: data.value?.['jobs_scenes__LIVE__jobsSceneID::name_display'] || '—'
                        }, null, 8, ["label", "value"])
                      ]),
                      _createElementVNode("div", _hoisted_62, [
                        _createVNode(_component_data_display, {
                          label: _unref(_localesStore).getLabel('330'),
                          value: data.value?.genre_display || '—'
                        }, null, 8, ["label", "value"])
                      ]),
                      (_unref(userStore).getContactType == 'Staff')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                            _createVNode(_component_data_display, {
                              label: _unref(_localesStore).getLabel('573'),
                              value: data.value?.live_type_display || '—'
                            }, null, 8, ["label", "value"])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _createVNode(_component_tw_table, {
                  placeholder: _unref(t)('placeholders.noLive'),
                  data: liveList.value,
                  loading: loading.value
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_tw_table_column, {
                      header: _unref(_localesStore).getLabel('102'),
                      prop: "jobs_scenes__jobs_live_ROLES__roleID::name_display"
                    }, null, 8, ["header"]),
                    _createVNode(_component_tw_table_column, {
                      header: _unref(_localesStore).getLabel('448'),
                      prop: "jobs_scenes__JOBS_LIVE__jobsSceneID::cost"
                    }, null, 8, ["header"]),
                    _createVNode(_component_tw_table_column, {
                      "class-name": "w-6",
                      "header-class-name": "w-6",
                      "align-text": "right"
                    }, {
                      default: _withCtx(({row}) => [
                        _createElementVNode("div", {
                          onClick: ($event: any) => (__props.showDetails(row, 'liveSong', null, null)),
                          class: "h-6 w-6 cursor-pointer"
                        }, [
                          _createElementVNode("img", {
                            class: _normalizeClass([liveHasSongs(row) ? 'linked-icon' : 'grayed-icon']),
                            src: _imports_4,
                            alt: "list icon"
                          }, null, 2)
                        ], 8, _hoisted_64)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["placeholder", "data", "loading"])
              ]))
            : _createCommentVNode("", true)
    ], 512), [
      [_vShow, childTabs.value?._tabs?.[_unref(userStore).getContactType == 'Staff' ? 5 : 4]?.current]
    ])
  ]))
}
}

})